export const giftCardsAmount = [
  { value: '30', label: '30' },
  { value: '60', label: '60' },
  { value: '100', label: '100' },
  { value: '120', label: '120' },
  { value: '200', label: '200' },
  { value: '500', label: '500' },
]

export const sendGiftCardToRecipientMethods: {
  value: string
  label: string
}[] = [
  {
    value: 'true',
    label: 'Yes',
  },
  {
    value: 'false',
    label: 'No',
  },
]
